
























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class RatingIconDefault extends Vue {
  @Prop({}) public value!: string | number
  @Prop({ default: 44 }) public width?: string | number
  @Prop({ default: 44 }) public height?: string | number
  @Prop({ default: 'currentColor' }) public iconColor?: string
}
